/**
 * 门户统一 SVG 图标（IconPark / iconfont 线性风格，24×24）
 * 新增图标须保持同套 1.5px 圆角描边，勿混用 Element el-icon
 */

/** @typedef {{ d: string, fill?: string, stroke?: string, sw?: number }} PortalIconPath */

/** @type {Record<string, PortalIconPath[]>} */
export const PORTAL_ICON_PATHS = {
  category: [
    { d: "M4 6h16M4 12h16M4 18h10" },
  ],
  path: [
    { d: "M3 7.5c0-1.1.9-2 2-2h5l2 2h7c1.1 0 2 .9 2 2v9c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-9z" },
    { d: "M8 11l2.5 2.5L14 10l3 4" },
  ],
  notebook: [
    { d: "M7 4h9c1.1 0 2 .9 2 2v14H9c-1.1 0-2-.9-2-2V4z" },
    { d: "M9 4v16" },
    { d: "M12 9h5M12 13h4" },
  ],
  edit: [
    { d: "M12 20h9" },
    { d: "M16.5 3.5a2.12 2.12 0 013 3L7 19l-4 1 1-4 12.5-12.5z" },
  ],
  user: [
    { d: "M12 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7z" },
    { d: "M5 20c0-3.5 3.13-6 7-6s7 2.5 7 6" },
  ],
  users: [
    { d: "M9 11a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" },
    { d: "M4 20c0-3 2.69-5.5 6-5.5" },
    { d: "M16 10.5a2 2 0 100-4" },
    { d: "M20 20c0-2.8-2.24-4.5-5-4.5" },
  ],
  teacher: [
    { d: "M12 3l7.5 3.5v5c0 4-3.5 6.5-7.5 7-4-.5-7.5-3-7.5-7v-5L12 3z" },
    { d: "M9 12l2 2 4-4" },
  ],
  project: [
    { d: "M12 2l2.2 6.8H21l-5.5 4 2.1 6.8L12 17.8 6.4 19.6l2.1-6.8L3 8.8h6.8L12 2z" },
  ],
  support: [
    { d: "M5 7.5a7 7 0 0114 0V13a2.5 2.5 0 01-2.5 2.5h-.8L13 18v-2.5H8.5A2.5 2.5 0 016 13V7.5z" },
    { d: "M9 18.5h6" },
  ],
  trophy: [
    { d: "M8 5h8v2.5a3.5 3.5 0 01-7 0V5z" },
    { d: "M6 5H4.5v1a2.5 2.5 0 002.5 2.5" },
    { d: "M18 5h1.5v1a2.5 2.5 0 01-2.5 2.5" },
    { d: "M10 14.5h4V18h-4z" },
    { d: "M8.5 20h7" },
  ],
  "arrow-right": [{ d: "M5 12h14M13 7l5 5-5 5" }],
  "arrow-left": [{ d: "M19 12H5M11 7l-5 5 5 5" }],
  "arrow-down": [{ d: "M12 5v14M7 14l5 5 5-5" }],
  clock: [
    { d: "M12 21a9 9 0 110-18 9 9 0 010 18z" },
    { d: "M12 7v5.5l3.5 2" },
  ],
  book: [
    { d: "M6 4.5h8.5A2.5 2.5 0 0117 7v12.5H8A2.5 2.5 0 015.5 17V6.5A2 2 0 016 4.5z" },
    { d: "M8 4.5V17" },
    { d: "M11 8.5h5M11 12h4" },
  ],
  calendar: [
    { d: "M5 6.5h14v13H5V6.5z" },
    { d: "M8 4v3.5M16 4v3.5M5 10.5h14" },
  ],
  gauge: [
    { d: "M12 21a8 8 0 110-16 8 8 0 010 16z" },
    { d: "M12 12l2.5-4" },
    { d: "M7.5 16a4.5 4.5 0 019 0" },
  ],
  medal: [
    { d: "M8.5 4.5h7l-1.2 5.5H9.7L8.5 4.5z" },
    { d: "M9.2 10l-1.8 9 4.3-2.5 4.3 2.5-1.8-9" },
  ],
  stages: [
    { d: "M4 7.5h5.5M4 12h9M4 16.5h13" },
    { d: "M17.5 6.5l2.5 2.5-2.5 2.5" },
  ],
  document: [
    { d: "M8.5 4.5h6.5l3 3v11.5H8.5A2 2 0 016.5 17V6.5a2 2 0 012-2z" },
    { d: "M15 4.5V8h3.5" },
    { d: "M10 12h6M10 15.5h4.5" },
  ],
  setting: [
    { d: "M12 15a3 3 0 100-6 3 3 0 000 6z" },
    { d: "M19.1 13.2a1.5 1.5 0 00.3 1.6l.1.1a1.8 1.8 0 01-2.5 2.5l-.1-.1a1.5 1.5 0 00-1.6-.3 1.5 1.5 0 00-.9 1.3V19a2 2 0 01-4 0v-.1a1.5 1.5 0 00-.9-1.3 1.5 1.5 0 00-1.6.3l-.1.1a1.8 1.8 0 01-2.5-2.5l.1-.1a1.5 1.5 0 00.3-1.6 1.5 1.5 0 00-1.3-.9H4a2 2 0 010-4h.1a1.5 1.5 0 001.3-.9 1.5 1.5 0 00-.3-1.6l-.1-.1a1.8 1.8 0 012.5-2.5l.1.1a1.5 1.5 0 001.6.3 1.5 1.5 0 00.9-1.3V4a2 2 0 014 0v.1a1.5 1.5 0 00.9 1.3 1.5 1.5 0 001.6-.3l.1-.1a1.8 1.8 0 012.5 2.5l-.1.1a1.5 1.5 0 00-.3 1.6 1.5 1.5 0 001.3.9H20a2 2 0 010 4h-.1a1.5 1.5 0 00-1.3.9z" },
  ],
  video: [
    { d: "M5.5 7.5h10A1.5 1.5 0 0117 9v6a1.5 1.5 0 01-1.5 1.5h-10A1.5 1.5 0 015 15V9a1.5 1.5 0 011.5-1.5z" },
    { d: "M17 10.5l4.5-2.5v7.5L17 13v-2.5z" },
  ],
  tools: [
    { d: "M5 8.5h14v10H5V8.5z" },
    { d: "M9.5 8.5V7a2.5 2.5 0 015 0v1.5" },
    { d: "M5 13h14" },
  ],
  briefcase: [
    { d: "M5 9.5h14v9H5v-9z" },
    { d: "M9 9.5V8a3 3 0 016 0v1.5" },
    { d: "M5 13h14" },
    { d: "M12 13v2.5" },
  ],
  link: [
    { d: "M10.5 13.5a3.5 3.5 0 010-5l1.5-1.5a3.5 3.5 0 015 5l-1 1" },
    { d: "M13.5 10.5a3.5 3.5 0 010 5l-1.5 1.5a3.5 3.5 0 01-5-5l1-1" },
  ],
  guide: [
    { d: "M6.5 5h10a1.5 1.5 0 011.5 1.5v12H8A1.5 1.5 0 016.5 17V5z" },
    { d: "M8.5 5v12" },
    { d: "M11.5 9h5M11.5 12.5h3.5" },
  ],
  star: [
    { d: "M12 2.8l2.35 5.9 6.35.55-4.8 4.15 1.45 6.2L12 16.9 6.65 19.6l1.45-6.2-4.8-4.15 6.35-.55L12 2.8z" },
  ],
  university: [
    { d: "M3.5 19.5h17" },
    { d: "M6.5 19.5V10l5.5-3.5L17.5 10v9.5" },
    { d: "M10 13.5h4v6h-4z" },
    { d: "M12 6.5v1.5" },
  ],
  course: [
    { d: "M4.5 9l7.5-3.5L19.5 9 12 12.5 4.5 9z" },
    { d: "M4.5 13l7.5 3.5L19.5 13" },
    { d: "M4.5 17l7.5 3.5L19.5 17" },
  ],
  cooperation: [
    { d: "M8 11.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" },
    { d: "M16 11.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" },
    { d: "M6.5 18.5c0-2.5 2.46-4.5 5.5-4.5" },
    { d: "M17.5 18.5c0-2.5-2.46-4.5-5.5-4.5" },
    { d: "M10 14.5h4" },
  ],
  lab: [
    { d: "M10 4.5h4l1 3.5H9l1-3.5z" },
    { d: "M9.5 8h5l-1.5 10H11L9.5 8z" },
    { d: "M8.5 14.5h7" },
    { d: "M14.5 6.5c1 .8 1.5 1.8 1.5 3" },
  ],
  code: [
    { d: "M8.5 8.5l-3.5 3.5 3.5 3.5" },
    { d: "M15.5 8.5l3.5 3.5-3.5 3.5" },
    { d: "M13.5 7.5l-3 9" },
  ],
  globe: [
    { d: "M12 21a9 9 0 110-18 9 9 0 010 18z" },
    { d: "M3.5 12h17" },
    { d: "M12 3c2.2 2.5 3.5 5.5 3.5 9s-1.3 6.5-3.5 9c-2.2-2.5-3.5-5.5-3.5-9s1.3-6.5 3.5-9z" },
  ],
  database: [
    { d: "M5.5 7c0-2 2.92-3.5 6.5-3.5s6.5 1.5 6.5 3.5-2.92 3.5-6.5 3.5-6.5-1.5-6.5-3.5z" },
    { d: "M5.5 12c0 2 2.92 3.5 6.5 3.5s6.5-1.5 6.5-3.5" },
    { d: "M5.5 17c0 2 2.92 3.5 6.5 3.5s6.5-1.5 6.5-3.5" },
    { d: "M5.5 7v10M18.5 7v10" },
  ],
  cpu: [
    { d: "M8.5 8.5h7v7h-7v-7z" },
    { d: "M10.5 5v2M13.5 5v2M10.5 17v2M13.5 17v2M5 10.5h2M5 13.5h2M17 10.5h2M17 13.5h2" },
  ],
  monitor: [
    { d: "M4.5 6.5h15v9h-15v-9z" },
    { d: "M9.5 19.5h5" },
    { d: "M12 15.5v4" },
  ],
  chart: [
    { d: "M5 19V6" },
    { d: "M5 19h14" },
    { d: "M9 15l2.5-3 2.5 2 4-5.5" },
  ],
  quiz: [
    { d: "M6.5 5.5h11v10h-11v-10z" },
    { d: "M9.5 9h5M9.5 12h3.5" },
    { d: "M10.5 18.5h3" },
  ],
  rocket: [
    { d: "M12 3.5c2.8 3.8 3.8 6.8 3.8 9.5a3.8 3.8 0 01-7.6 0c0-2.7 1-5.7 3.8-9.5z" },
    { d: "M9.5 16.5l-1.8 4 4.8-2.2 4.8 2.2-1.8-4" },
    { d: "M12 10v2.5" },
  ],
  magic: [
    { d: "M5 19l6.5-6.5" },
    { d: "M13.5 6.5l5 5" },
    { d: "M7 7.5l1.5 1.5M16.5 16.5l1.5 1.5M17 7.5l-1.5 1.5M7.5 16.5l-1.5 1.5" },
  ],
  tag: [
    { d: "M5 12V7.5A2.5 2.5 0 017.5 5H12l7 7-7 7-7-7z" },
    { d: "M9.5 9.5h.01", fill: "currentColor", stroke: "none" },
  ],
  check: [
    { d: "M6 12.5l3.5 3.5L18 8.5" },
  ],
  cloud: [
    { d: "M7.5 17.5h9.5a3.5 3.5 0 000-7 4.5 4.5 0 00-8.6-1.5A3 3 0 007.5 17.5z" },
  ],
  search: [
    { d: "M11 17a6 6 0 110-12 6 6 0 010 12z" },
    { d: "M15.5 15.5L20 20" },
  ],
  bell: [
    { d: "M12 4.5a5 5 0 00-5 5v3.5l-1.5 2.5h13l-1.5-2.5V9.5a5 5 0 00-5-5z" },
    { d: "M10 18.5a2 2 0 004 0" },
  ],
  certificate: [
    { d: "M7 5.5h10v11H7v-11z" },
    { d: "M9.5 9h5M9.5 12h5" },
    { d: "M9 18.5l3-2 3 2v-2H9v2z" },
  ],
  platform: [
    { d: "M5 8.5h14v9H5v-9z" },
    { d: "M8.5 12h7M8.5 14.5h4.5" },
    { d: "M12 5.5v3" },
  ],
  lock: [
    { d: "M8 11.5h8v7.5H8v-7.5z" },
    { d: "M9.5 11.5V9a2.5 2.5 0 015 0v2.5" },
  ],
  key: [
    { d: "M8.5 12a3.5 3.5 0 107 0c0-1.3-.7-2.4-1.8-3L15 6h3v3l-2.8 2.8" },
  ],
  logout: [
    { d: "M11 7.5V5.5a1 1 0 011-1h5a1 1 0 011 1v13a1 1 0 01-1 1h-5a1 1 0 01-1-1v-2" },
    { d: "M7 12h9M14 9l3 3-3 3" },
  ],
  warning: [
    { d: "M12 5.5l8 14H4l8-14z" },
    { d: "M12 10v3.5M12 16.5h.01", fill: "currentColor", stroke: "none" },
  ],
  folder: [
    { d: "M5 7.5h5.5l1.5 1.5H19v9H5V7.5z" },
  ],
  coin: [
    { d: "M12 21a9 9 0 110-18 9 9 0 010 18z" },
    { d: "M12 7.5v2M12 14.5v2" },
    { d: "M8.5 12h7" },
  ],
  qrcode: [
    { d: "M5.5 5.5h5v5h-5v-5zM13.5 5.5h5v5h-5v-5zM5.5 13.5h5v5h-5v-5z" },
    { d: "M13.5 13.5h2v2h-2zM17.5 13.5h1v1h-1zM17.5 17.5h1v1h-1zM15.5 17.5h2v1h-2z" },
  ],
  /** 顶栏 Mega 下拉：iconfont 线性风格（阿里矢量图标库教育/办公类） */
  "nav-career": [
    { d: "M8 8.5V7a4 4 0 118 0v1.5" },
    { d: "M6 8.5h12a2 2 0 012 2v7.5a1.5 1.5 0 01-1.5 1.5H5.5A1.5 1.5 0 014 18V10.5a2 2 0 012-2z" },
    { d: "M9.5 13h5" },
    { d: "M12 13v2.5" },
  ],
  "nav-competition": [
    { d: "M8.5 4.5h7v3a3.5 3.5 0 01-7 0v-3z" },
    { d: "M6 5.5H4.5v1.2a2.2 2.2 0 002.2 2.2" },
    { d: "M18 5.5h1.5v1.2a2.2 2.2 0 01-2.2 2.2" },
    { d: "M10 14.5h4v2.5H10z" },
    { d: "M8.5 19.5h7" },
    { d: "M12 11.5v3" },
  ],
  "nav-route": [
    { d: "M5.5 18.5l4.5-7.8 3.2 3.2L18.5 6.5" },
    { d: "M16.5 6.5h2v2" },
    { d: "M5.5 18.5a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2z" },
    { d: "M18.5 6.5a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2z" },
  ],
  "nav-exam": [
    { d: "M7 5.5h10a1.5 1.5 0 011.5 1.5v11a1.5 1.5 0 01-1.5 1.5H7A1.5 1.5 0 015.5 18V7a1.5 1.5 0 011.5-1.5z" },
    { d: "M9 9h6M9 12.5h6M9 16h4" },
    { d: "M9.5 19.5l2.5-1.5 2.5 1.5" },
  ],
  "nav-practice": [
    { d: "M8 4.5h8l1.5 3H6.5l1.5-3z" },
    { d: "M7.5 8h9l-1.2 11H8.7L7.5 8z" },
    { d: "M10 12h4M10 15h3" },
    { d: "M14.5 6.5c.8.6 1.2 1.4 1.2 2.3" },
  ],
};

/** Element 旧图标名 → 门户语义名 */
const EL_ICON_ALIAS = {
  "el-icon-menu": "category",
  "el-icon-guide": "path",
  "el-icon-notebook-2": "notebook",
  "el-icon-edit-outline": "edit",
  "el-icon-user": "user",
  "el-icon-user-solid": "teacher",
  "el-icon-s-opportunity": "project",
  "el-icon-chat-dot-round": "support",
  "el-icon-trophy": "trophy",
  "el-icon-arrow-right": "arrow-right",
  "el-icon-right": "arrow-right",
  "el-icon-back": "arrow-left",
  "el-icon-arrow-left": "arrow-left",
  "el-icon-arrow-down": "arrow-down",
  "el-icon-time": "clock",
  "el-icon-reading": "book",
  "el-icon-date": "calendar",
  "el-icon-odometer": "gauge",
  "el-icon-medal": "medal",
  "el-icon-s-operation": "stages",
  "el-icon-document": "document",
  "el-icon-setting": "setting",
  "el-icon-video-camera": "video",
  "el-icon-suitcase": "briefcase",
  "el-icon-link": "link",
  "el-icon-collection-tag": "tag",
  "el-icon-document-checked": "check",
  "el-icon-magic-stick": "magic",
  "el-icon-cpu": "cpu",
  "el-icon-monitor": "monitor",
  "el-icon-data-line": "chart",
  "el-icon-s-promotion": "rocket",
  "el-icon-school": "university",
  "el-icon-office-building": "university",
  "el-icon-s-custom": "users",
  "el-icon-s-grid": "course",
  "el-icon-s-cooperation": "cooperation",
  "el-icon-cloudy": "cloud",
  "el-icon-search": "search",
  "el-icon-bell": "bell",
  "el-icon-lock": "lock",
  "el-icon-key": "key",
  "el-icon-switch-button": "logout",
  "el-icon-warning": "warning",
  "el-icon-folder-opened": "folder",
  "el-icon-collection": "book",
  "el-icon-data-board": "chart",
  "el-icon-connection": "link",
  "el-icon-coin": "coin",
  "el-icon-full-screen": "qrcode",
  "el-icon-check": "check",
  "el-icon-edit": "edit",
};

/**
 * @param {string} name
 * @returns {string}
 */
export function resolvePortalIcon(name) {
  if (!name) return "tag";
  const raw = String(name).trim();
  if (PORTAL_ICON_PATHS[raw]) return raw;
  if (EL_ICON_ALIAS[raw]) return EL_ICON_ALIAS[raw];
  return "tag";
}

/**
 * @param {string} name
 * @returns {PortalIconPath[]}
 */
export function getPortalIconPaths(name) {
  const key = resolvePortalIcon(name);
  return PORTAL_ICON_PATHS[key] || PORTAL_ICON_PATHS.tag;
}
